import React, { useState, useEffect } from "react";
import API from "../api";
import "../Style/SillPdf.css"

const SliPdf = () => {
    const [fileInfo, setFileInfo] = useState(null);
    const [file, setFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [error, setError] = useState("");

    useEffect(() => {
        fetchFileInfo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        return () => {
            if (previewUrl) URL.revokeObjectURL(previewUrl);
        };
    }, [previewUrl]);

    const fetchFileInfo = async () => {
        try {
            const res = await API.get("/files");
            setFileInfo(res.data?.[0] || null);
        } catch (err) {
            console.error("Error fetching file info:", err);
        }
    };

    const handleUpload = async (e) => {
        e.preventDefault();
        setError("");
        if (!file) {
            setError("Խնդրում ենք ընտրել ֆայլը։");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);

        try {
            await API.post("/files/upload", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            setFile(null);
            fetchFileInfo();
        } catch (err) {
            console.error("Upload error:", err);
            setError(err.response?.data?.message || "Վերբեռնման սխալ։");
        }
    };

    const handleDelete = async () => {
        try {
            // The doc key no longer varies by language — there's a single
            // public-offer document — but the route still takes a path
            // param for backward compatibility with the existing endpoint.
            await API.delete(`/files/delete/public_offer`);
            setFileInfo(null);
            if (previewUrl) {
                URL.revokeObjectURL(previewUrl);
                setPreviewUrl(null);
            }
        } catch (err) {
            console.error("Delete error:", err);
            setError(err.response?.data?.message || "Ջնջման սխալ։");
        }
    };

    const handlePreview = async () => {
        try {
            const res = await API.get("/pdf-padding", { responseType: "blob" });
            const url = URL.createObjectURL(res.data);
            setPreviewUrl(url);
            window.open(url, "_blank", "noopener,noreferrer");
        } catch (err) {
            console.error("Preview error:", err);
            setError("Չհաջողվեց բացել ֆայլը։");
        }
    };

    return (
        <div className="sli-pdf-container">
            <h1 className="sli-pdf-title">Հրապարակային օֆերտայի ֆայլի կառավարում</h1>
            <form onSubmit={handleUpload} className="sli-pdf-form">
                <input
                    type="file"
                    accept="application/pdf"
                    onChange={(e) => setFile(e.target.files[0])}
                    required
                    className="sli-pdf-input"
                />
                <button type="submit" className="sli-pdf-upload-btn">
                    Վերբեռնել
                </button>
            </form>

            {error && <p className="error-text">{error}</p>}

            <h2 className="sli-pdf-subtitle">Ընթացիկ ֆայլ</h2>
            {fileInfo ? (
                <ul className="sli-pdf-list">
                    <li className="sli-pdf-item">
                        <button onClick={handlePreview} className="sli-pdf-link">
                            Բացել ընթացիկ PDF-ը
                        </button>
                        <button onClick={handleDelete} className="sli-pdf-delete-btn">
                            Ջնջել
                        </button>
                    </li>
                </ul>
            ) : (
                <p>Ֆայլ դեռ վերբեռնված չէ։</p>
            )}
        </div>
    );
};

export default SliPdf;
